<template>
  <layout>
    <div
      class="sticky top-0 space-y-1 pb-4 pt-6 px-4 sm:p-6 bg-white flex-col space-y-2 items-center justify-between border-b border-b-gray-200"
    >
      <ArrowNarrowLeft
        class="w-6 sm:w-0 sm:hidden -ml-0.5 text-gray-900"
        @click="handleBack"
      />
      <div>
        <h1 class="text-gray-900 text-xl font-medium">
          {{ t("admin.settings.personal.profile.title") }}
        </h1>
        <p class="text-gray-500 text-sm">
          {{ t("admin.settings.personal.profile.description") }}
        </p>
      </div>
    </div>
    <div class="flex flex-col space-y-6 p-6 max-w-4xl">
      <Errors />

      <div class="grid sm:grid-cols-3 gap-x-10">
        <div>
          <span class="col-span-1 text-sm font-medium">
            {{ t("admin.settings.personal.profile.photo.title") }}
          </span>
          <p class="text-gray-500 text-sm font-medium">
            {{ t("admin.settings.personal.profile.photo.description") }}
          </p>
        </div>
        <AvatarInput @file="handleImagesSelected" :details="user" />
      </div>

      <hr />

      <div class="grid grid-cols-3 gap-x-10">
        <span class="col-span-1 text-sm font-medium">
          {{ t("admin.settings.personal.profile.first_name") }}
        </span>
        <input
          v-model="details.firstname"
          type="text"
          name="firstname"
          id="firstname"
          class="col-span-2 block w-full rounded-sm border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
        />
      </div>

      <hr />

      <div class="grid grid-cols-3 gap-x-10">
        <span class="col-span-1 text-sm font-medium">
          {{ t("admin.settings.personal.profile.last_name") }}
        </span>
        <input
          v-model="details.lastname"
          type="text"
          name="firstname"
          id="firstname"
          class="col-span-2 block w-full rounded-sm border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
        />
      </div>

      <hr />

      <div class="flex justify-end">
        <primary-button
          :label="t('components.buttons.save')"
          @click="handleUpdateProfile"
        />
      </div>
    </div>
    <trial-countdown />
  </layout>
</template>

<script setup>
import PersistentLayout from "@/Layouts/PersistentLayout.vue";
import Layout from "@/Tailwind/Layouts/UserSettings.vue";
import { usePage } from "@inertiajs/vue3";
import { reactive, ref } from "vue";
import PrimaryButton from "@/Tailwind/Components/Buttons/PrimaryButton.vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import ArrowNarrowLeft from "@/Tailwind/Icon/ArrowNarrowLeft.vue";
import AvatarInput from "@/Tailwind/Components/Settings/Users/AvatarInput.vue";

import { useI18n } from "vue-i18n";
import Errors from "@/Tailwind/Components/Errors.vue";
import TrialCountdown from "@/Tailwind/Components/TrialCountdown.vue";

defineOptions({ layout: PersistentLayout });

const { t } = useI18n();

const photo = ref(null);

const user = usePage().props.auth.user;
const details = reactive({
  firstname: user.firstname,
  lastname: user.lastname,
});

function handleImagesSelected(file) {
  photo.value = file;
}

function handleUpdateProfile() {
  router.post(route("settings.user.profile.update"), {
    // router.put doesn't work here because an imagine is included in the request.
    _method: "PATCH",

    avatar: photo.value,
    ...details,
  });
}

function handleBack() {
  router.visit(route("settings.user.personal"));
}
</script>
